import { createSlice } from '@reduxjs/toolkit';

export interface LinzeSalesReportState {
    fetching: string;
    jobId: string | null;
    fileUrl: string | null;
    fileName: string | null;
    totalRecords: number | null;
    error: string | null;
}

const initialState: LinzeSalesReportState = {
    fetching: "",
    jobId: null,
    fileUrl: null,
    fileName: null,
    totalRecords: null,
    error: null,
};

const statusToFetching = (status: string) => {
    if (status === "pending") return "polling";
    return status;
};

const linzeSalesReportSlice = createSlice({
    name: 'linzeSalesReport',
    initialState,
    reducers: {
        requestReportRequest: (state) => {
            state.fetching = "requesting";
            state.jobId = null;
            state.fileUrl = null;
            state.fileName = null;
            state.totalRecords = null;
            state.error = null;
        },
        requestReportSuccess: (state, action) => {
            const { jobId, status, fileUrl, fileName, totalRecords, error } = action.payload;
            state.fetching = statusToFetching(status);
            state.jobId = jobId;
            state.fileUrl = fileUrl;
            state.fileName = fileName;
            state.totalRecords = totalRecords;
            state.error = error;
        },
        requestReportFailure: (state) => {
            state.fetching = "error";
            state.error = "Ha ocurrido un error al solicitar el reporte. Intentá de nuevo.";
        },
        checkReportSuccess: (state, action) => {
            const { jobId, status, fileUrl, fileName, totalRecords, error } = action.payload;
            state.fetching = statusToFetching(status);
            state.jobId = jobId;
            state.fileUrl = fileUrl;
            state.fileName = fileName;
            state.totalRecords = totalRecords;
            state.error = error;
        },
        checkReportFailure: (state) => {
            state.fetching = "error";
            state.error = "Ha ocurrido un error al consultar el estado del reporte.";
        },
        cleanLinzeSalesReport: (state) => {
            state.fetching = "";
            state.jobId = null;
            state.fileUrl = null;
            state.fileName = null;
            state.totalRecords = null;
            state.error = null;
        }
    }
});

export const {
    requestReportRequest,
    requestReportSuccess,
    requestReportFailure,
    checkReportSuccess,
    checkReportFailure,
    cleanLinzeSalesReport
} = linzeSalesReportSlice.actions;

export default linzeSalesReportSlice.reducer;
